<template>
  <div>
    <sc-modal
      :active.sync="showModal">
      <sc-modal-tag :show-modal="showModal" />
    </sc-modal>

    <sc-form
      ref="form"
      :form="form"
      :rules="rules"
      @submit="getTagsForm">
      <template slot="fields" slot-scope="{ fields }">
        <div class="columns">
          <div class="column">
            <sc-field
              label="Transportadora"
              prop="logistic_provider">
              <sc-logistic-provider-dropdown v-model="fields.logistic_provider"/>
            </sc-field>
          </div>

          <div class="column">
            <sc-field
              label="Método de entrega"
              prop="delivery_methods">
              <sc-delivery-method-dropdown
                v-model="fields.delivery_methods"
                :logistic-provider-id="fields.logistic_provider"
                multiple />
            </sc-field>
          </div>

          <div class="column">
            <sc-field label="Tipo de Documento" prop="document_type">
              <sc-select v-model="fields.document_type" expanded>
                <option selected value="cte_document">CTe</option>
                <option value="nfe_document">NFe</option>
                <option value="nfs_document">NFS</option>
              </sc-select>
            </sc-field>
          </div>
        </div>
      </template>

      <template slot="actions" slot-scope="{ isValid }">
        <div class="columns">
          <div class="column">
            <sc-button
              text="Exportar para Excel"
              :loading="loading"
              :disabled="!isValid"
              @click="exportExcelTags"/>

            <sc-button
              type="submit"
              theme="primary"
              text="Consultar"/>
          </div>
        </div>
      </template>
    </sc-form>

    <div class="box">
      <div class="columns">
        <div class="column has-text-right">
          <sc-button
            theme="primary"
            text="Gerar nova tag"
            @click="createTag()" />
        </div>
      </div>

      <sc-table
        :data="tags"
        :per-page="pagination.limit"
        default-sort="tms_name"
        paginated>
        <template slot-scope="{ row }">
          <sc-table-column
            label="Intelipost"
            field="tms_name"
            sortable>
            {{ row.tms_name }}
          </sc-table-column>

          <sc-table-column
            label="Transportadora"
            field="logistic_provider_name"
            sortable>
            {{ row.logistic_provider_name }}
          </sc-table-column>

          <sc-table-column
            label="Tipo"
            field="taxes_type"
            sortable>
            {{ row.taxes_type }}
          </sc-table-column>

          <sc-table-column
            label="Tag Nomenclatura"
            field="tag_name"
            sortable>
            {{ row.tag_name }}
          </sc-table-column>

          <sc-table-column
            label="Tag Valor"
            field="tag_value"
            sortable>
            {{ row.tag_value }}
          </sc-table-column>

          <sc-table-column label="Ações">
            <sc-button
              confirm
              theme="danger"
              text="Excluir"
              @click="deleteTag(row.id)"/>
          </sc-table-column>
        </template>

        <template slot="footer">
          <p v-if="totalCount">
            <strong>Total de registros:</strong>
            <span>{{ totalCount }}</span>
          </p>
        </template>

        <template slot="bottom-left">
          <sc-table-per-page v-model="pagination.limit" />
        </template>

        <template slot="empty">
          <sc-table-empty />
        </template>
      </sc-table>
    </div>
  </div>
</template>

<script>
import {
  ScButton,
  ScDeliveryMethodDropdown,
  ScForm,
  ScField,
  ScLogisticProviderDropdown,
  ScModal,
  ScModalCard,
  ScSelect,
  ScTable,
  ScTableColumn,
  ScTableEmpty,
  ScTablePerPage,
  ScToast,
} from '@intelipost-js/secure-components';
import { createNamespacedHelpers } from 'vuex';
import ScModalTag from '../sc-modal-tag/ScModalTag';

const {
  mapState,
  mapActions,
} = createNamespacedHelpers('recon/xmlCteTags');

export default {
  name: 'sc-from-to-xml-cte',
  data() {
    return {
      showModal: false,
      pagination: {
        page: 1,
        limit: 10,
      },
      rules: {
        document_type: [
          {
            required: true,
            message: 'Selecione o tipo do documento',
          },
        ],
        logistic_provider: [
          {
            required: true,
            message: 'Selecione a transportadora',
          },
        ],
        delivery_methods: [
          {
            required: true,
            message: 'Selecione um método de entrega',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState([
      'form',
      'tags',
      'loading',
    ]),
    totalCount() {
      return this.tags.length;
    },
  },
  methods: {
    ...mapActions([
      'getTags',
      'exportToExcel',
      'deleteTag',
    ]),
    createTag() {
      this.showModal = true;
    },
    getTagsForm(form) {
      this.getTags(form);
    },
    exportExcelTags(form) {
      return this.exportToExcel(form)
        .then(() =>
          ScToast.success(
            'O relatório está sendo gerado, assim que finalizado estará disponível na seção Meus Arquivos.',
          ),
        );
    },
  },
  components: {
    ScButton,
    ScDeliveryMethodDropdown,
    ScForm,
    ScField,
    ScLogisticProviderDropdown,
    ScModal,
    ScModalCard,
    ScModalTag,
    ScSelect,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTablePerPage,
    ScToast,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/components/sc-from-to-xml-cte/ScFromToXmlCte.vue